import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Select from 'react-select'

import PopUp from '../../../../commonModules/interface/PopUp';
import Photos from '../../../../commonModules/interface/input-files';
import { Grid, Box } from '@material-ui/core';
import InputText, { TextArea, InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { toast } from 'react-toastify';

class ReturnProd extends Component {
    state = { 
        comments: "",
        quantity: "",
        serial_number:"",
        shop:"",
        shopDisplay:{},
        files:[],
        errors: {
            comments: "",
            quantity: "",
            shop:"",
        }
    }
    createShopList = () => {
        const list = []
        const { SHOPS } = this.props
        Object.keys(SHOPS).map( ID =>{ 
            const shop = SHOPS[ID]                    
            let selected = !!shop.shop_disabled
            if(this.state.shop === ID) {  // already selected   
                selected = true 
            } 
            list.push (       
                {value:ID, label:shop.name, disabled:selected} 
            )
        })
        
        return list
    }
    setFiles = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        this.setState({
            files:list
        })
    }
            
    handleSelect = (option, name) => {
        let value = option.value
        let displayName = name +'Display'
        this.setState({
            [name]:value,
            [displayName]:option,
        })
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    validate = () =>  {
        let required = [
            "quantity",
            "shop", 
            "comments",
        ]
        let errors = {}
        let noErrors = true
        required.forEach( field => {
            if ( isEmpty( this.state[field] ) ) {
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }

        }) 
        this.setState({errors})
        return noErrors
    }
    handleSubmit = async () => {
        if(this.validate()){

            const data = {
                sav_product_id:this.props.return_product.id,
                sav_sale_id:this.props.return_sale,
                sav_quantity:parseInt(this.state.quantity),
                sav_shop_id:this.state.shop,
                sav_last_status:"WAITING",
                sav_action: {
                    action_ts: new Date(),
                    action_status: "WAITING",
                    action_comment: this.state.comments,
                    action_files: this.state.files
                },
                sav_time_creation: new Date(),
                sav_time_update: new Date()
            }
            console.log('====================================');
            console.log("HANDLE SUBMIT ", {data});
            console.log('====================================');
            try {
                const req = await fetch("/sav/addInSAV",{
                    method:'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body:JSON.stringify({
                        data,
                    }),
                    credentials: 'same-origin',
                })
                let savID = await req.json()
    
                console.log('====================================');
                console.log("HANDLE SUBMIT RES",{savID});
                console.log('====================================');
                if(!savID.error){
    
                    data.id = savID
                    this.props.updateSav(data)
                    toast.success( "OK")
                    this.props.closeAll() // back to List
                } else {
                    // this.notif("error")
                    toast.error(  savID.error)
                    console.log('====================================');
                    console.log("[ERROR] HANDLE SUBMIT ", savID.error);
                    console.log('====================================');
                }
            } catch (error) {
                toast.error(  "KO")
                console.log('====================================');
                console.log("[ERROR] HANDLE SUBMIT ", error);
                console.log('====================================');
            }
        } else {
            toast.error(  "form KO")
            console.log('====================================');
            console.log("Errors in form");
            console.log('====================================');
        }
    }
    render() {
        return (
            <PopUp 
                title="Envoyer en SAV" 
                close={this.props.close} 
                block={true}
                submitAction={ this.handleSubmit }
                submitTitle="Valider" 
                maxWidth="sm"
                // disabledSubmit={this.props.STATE.sales.fetching || this.state.sending}
            >
                <Box>
                    <Grid container spacing={2}>
                        <Grid xs={12}>
                            <InputSelectMagasin
                                options={this.createShopList()}
                                value={this.state.shopDisplay}
                                onChange={(option) => this.handleSelect(option,"shop")}
                                isOptionDisabled={(option)=>option.disabled === true}
                                error={this.state.errors.shop}
                                label="Magasin"
                            /> 
                            {/* <div className={"form-group "+ (this.state.errors.shop ? "has-error" : "") }>
                                <label htmlFor="shop" className="control-label">Magasin</label>
                                <div>
                                    <small className="help-block">{this.state.errors.shop}</small>
                                </div>
                            </div> */}
                        </Grid>
                        <Grid xs={12}>
                            <InputText 
                                value={this.state.serial_number} 
                                name="serial_number" 
                                onChange={this.handleChange} 
                                label="Numéro de série"
                                error={this.state.errors.serial_number}
                            />
                        </Grid>
                        <Grid xs={12}>
                            <InputText 
                                value={this.state.quantity} 
                                name="quantity" 
                                onChange={this.handleChange} 
                                type="number"
                                label="Quantité"
                                error={this.state.errors.quantity}
                            />
                        </Grid>
                        <Grid xs={12}>
                            {/* <div className={"form-group " + (this.state.errors.comments ? "has-error" : "") }>
                                <label htmlFor="comments" className="control-label">Défauts</label>
                                <div className="fg-line ">      
                                    <textarea 
                                        className="form-control auto-size" 
                                        placeholder="Problèmes défauts ..." 
                                        rows={4}
                                        value={this.state.comments} 
                                        name="comments" 
                                        onChange={this.handleChange} 
                                    ></textarea>
                                </div>
                                <small className="help-block">{this.state.errors.comments}</small>
                            </div> */}
                            <TextArea
                                placeholder="Problèmes défauts ..." 
                                rows={4}
                                value={this.state.comments} 
                                name="comments" 
                                onChange={this.handleChange} 
                                error={this.state.errors.comments}
                                title="Défauts"
                                required
                            />
                        </Grid>
                        <Box p={2}>
                            {/* <h5>
                                <span>Joindre Fichier(s)</span> 
                            </h5> */}
                            <Photos photoList={this.setFiles} photos={this.state.files === null ? [] : this.state.files } file />
                        </Box>
                    </Grid>
                    {/* <div>
                        <button className="btn btn-info" onClick={this.handleSubmit}>Envoyer</button>
                    </div> */}
                </Box>
                        
            </PopUp>
        );
    }
}

export default ReturnProd;